export default "__VITE_ASSET__1db1b106__"